export default "__VITE_ASSET__CxGg1Yt7__"